import React from 'react';

const SvgPlay2 = props => (
    <svg width="1em" height="1em" viewBox="0 0 8 10" {...props}>
        <path d="M1.28452 0.129262L7.59879 4.14671C7.99521 4.39893 8.11881 4.93566 7.87486 5.34552C7.80571 5.46169 7.71115 5.55946 7.59879 5.63095L1.28452 9.64839C0.888098 9.90062 0.368974 9.77282 0.125023 9.36296C0.0432801 9.22563 0 9.06753 0 8.90627V0.871381C0 0.390131 0.377337 0 0.842806 0C0.998776 0 1.15169 0.0447474 1.28452 0.129262Z"/>
    </svg>
);

export default SvgPlay2;
